<template>
  <div 
    :class="{ 'invalid': !isValid, 'valid': isValid}"
    v-click-outside="closeComplete"
  >
    <label v-if="!hasNoLabel" :for="name">{{label}}</label>
    <div v-if="!isValid" class="error">{{ errorDescription }}</div>
    <input 
      autocomplete="off"
      :id="name" 
      :name="name" 
      :disabled="isDisabled" 
      :placeholder="placeholder" 
      :value="newVal"
      :class="{'autocomplete-active': this.isOpen}"
      @input="updateField($event)"
      @focus="openComplete"
      @keyup.enter="selectItem(0)"
    >
    <div 
      class="select-autocomplete"
      :class="{'select-lessTop': this.hasLessTop, 'select-moreTop': this.hasMoreTop}" 
      v-if="this.isOpen && this.searchTerm.length > 0"
    >
      <div 
        class="select-row"
        v-for="(result, index) in searchResult" 
        :key="index"
        @click="selectItem(index)"
      >
        <span class="main-step">{{result.name}}</span>
        <span v-if="name == 'RawMaterials'" class="equipment-step full-width">- {{result.description}}</span>
        <span v-else-if="name == 'DeviceRef'" class="equipment-step full-width">- {{result.desc}}</span>
        <span v-else-if="name == 'ProductionFlow'" class="equipment-step full-width">- {{result.id}}</span>
      </div>
      <div
        class="select-row"
        v-if="searchResult.length <= 0" 
        :key="index"
      >
        <span v-if="isLoading" class="equipment-step full-width">loading devices ...</span>
        <span v-else class="equipment-step full-width">No devices found</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed : {},
  props: {
    searchUrl: String,
    label: String,
    name: String,
    value: String,
    isTextArea: Boolean,
    isDisabled: Boolean,
    placeholder: String,
    hasLessTop: {
      type: Boolean,
      default: false
    },
    hasMoreTop: {
      type: Boolean,
      default: false
    },
    hasNoLabel: {
      type: Boolean,
      default: false
    },
    validation: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      newVal: '',
      searchTerm: '',
      searchResult:[],
      isOpen: false,
      isLoading: false,
      selectedItem: null,
      isValid: Boolean,
      errorDescription: this.label + ' is not valid'
    }
  }, 
  mounted() {
    this.newVal = this.value
  },
  methods: {
    selectItem(index) {    
      this.selectedItem = this.searchResult[index]
      this.newVal = this.selectedItem.name
      this.$emit("selectedItem", this.selectedItem)
      this.closeComplete()
      this.searchTerm = ''
      this.searchResult = []
    },
    updateField(event) {
      this.newVal = event.target.value
      this.searchTerm = event.target.value
      this.getResults()
      this.$emit('input', event.target.value)
    },      
    getResults() {
      var that = this
      this.isLoading = true
      if (this.searchTerm != "") {
        this.$http.get(this.$endpoint + this.searchUrl + "search/" + this.searchTerm)
        .then(response => {
          that.searchResult = []
          switch(this.name) {
            case "ProductionFlow":
              var i;
              for (i = 0; i < response.data.length; i++) {
                that.searchResult.push({'id': response.data[i].flowID, 'name': response.data[i].name})
              }
              break;
            case "RawMaterials":
              for (i = 0; i < response.data.length; i++) {
                that.searchResult.push({'id': response.data[i].rawMaterialID, 'name': response.data[i].ref, 'description': response.data[i].description})
              }
              break;
            case "DeviceRef":
              for (i = 0; i < response.data.length; i++) {
                var currentPartID
                switch(this.searchUrl) {
                  case "management/devices/assemblies/":
                    console.log('setting id thing')
                    currentPartID = response.data[i].deviceID
                    break;
                  case "management/devices/single/":
                    currentPartID = response.data[i].bonPartID
                    break;
                  case "management/devices/subparts/":
                    currentPartID = response.data[i].deviceID
                    break;
                }
                that.searchResult.push({'id': response.data[i].ref, 'flowID': response.data[i].flowID, 'name': response.data[i].ref,'ref': response.data[i].ref, 'desc': response.data[i].description, "deviceID": currentPartID })
              }
          }
          that.isLoading = false
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$store
            .dispatch("logout")
            .then(() => this.$router.push("/login"))
            .catch(err => console.log(err));
          } else {
            that.$swal(
              'Oops that went wrong?',
              `Please contact the admin with the following info: ${ error }`,
              'error'
            );
          }
        })
      }
    },
    openComplete() {
      this.isOpen = true
    },
    closeComplete() {
      this.isOpen = false
    },
  },
  watch: {
    validation: function(newVal, oldVal) {
      this.isValid = newVal
    },
    value: function(val) {
      this.newVal = val
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/inputs";
@import "@/style/components/autocompleteList";

.autocomplete-active {
  z-index: 101;
}

.icon.autocomplete-active {
  z-index: 102;
}

.select-autocomplete {
  width: 100%;
}
</style>
